import { useQuery } from 'react-query';
import { getUser } from 'src/services/api/users';

function useGetUser(user, params) {
  return useQuery(['user', user, params], (key, user, params) => getUser(user, params));
}

export default useGetUser;
